/* eslint-disable no-open-modules-imports */

import { CommentConfigDemoFeature, DemoSecondaryFeature } from 'feature/comments/comment-config';
import { DemoFilterFeature } from 'feature/comments/demo-filter';
import { LengthLimitFeature } from 'feature/comments/length-limit';
import { ReplyNotificationsFeature } from 'feature/comments/reply-notifs';
import { UpvoteFeature } from 'feature/comments/upvote';
import { ExportCommentsFeature, ImportCommentsFeature } from 'feature/developer/import-export';
import type { FeatureGroup } from 'feature/feature-helpers';
import { CHOOSEONE, COMPOSITE, SECTION } from 'feature/feature-helpers';
import { OpenLinksInNewTabFeature } from 'feature/general/open-links-in-new-tab';
import { ModerateWithGPTFeature, ModerateWithJigsawFeature, PreModeratorFeature } from 'feature/moderation/ai-premoderator';
import { HideRejectedFeature } from 'feature/moderation/hide-rejected';
import { HumanReviewsEverythingFeature } from 'feature/moderation/human-reviews-everything';
import { ReportCommentFeature } from 'feature/moderation/report-comment';
import { CloseConversationFeature } from 'feature/question/close-conversation';
import { CommentSliderFeature } from 'feature/question/comment-slider';
import { CommunityGuidelinesFeature } from 'feature/question/community-guidelines';
import { AIQualityRankingFeature, ShowRankingFeaturesFeature } from 'feature/ranking/ai-quality-ranking';
import { RankingSelectorFeature } from 'feature/ranking/ranking-selector';
import { MostReactedFeature, MostRecentFeature, MostUpvotedFeature, OldestFeature } from 'feature/ranking/simple-ranking';
import { BasicTeaserFeature } from 'feature/teaser/basic-teaser';
import { TranslationFeature } from 'open-modules/srg/translation/TranslationFeature';
import { ArticleTopicTaggingFeature } from 'open-modules/zdf/feature/article-topic-tag';
import { ConvoMatchFeature } from 'open-modules/zdf/feature/convo-match';
import { AutoApproveFeature } from 'open-modules/zdf/feature/premoderation/AutoApproveFeature';
import { BlocklistFeature } from 'open-modules/zdf/feature/premoderation/blocklist';
import { VideoQuoteFeature } from 'open-modules/zdf/feature/video-quote';
import { t } from 'util/stdtypes';

export const simpleCommentsFeatures: FeatureGroup[] = [
    SECTION(t('Developer'), [
        COMPOSITE(CommentConfigDemoFeature, [DemoSecondaryFeature]),
        DemoFilterFeature,
        ImportCommentsFeature,
        ExportCommentsFeature,
    ]),
    SECTION(t('General'), [
        UpvoteFeature,
        LengthLimitFeature,
        BasicTeaserFeature,
        ReplyNotificationsFeature,
        CloseConversationFeature,
        OpenLinksInNewTabFeature,
    ]),
    SECTION(t('Ranking'), [
        RankingSelectorFeature,
        MostRecentFeature,
        OldestFeature,
        MostUpvotedFeature,
        MostReactedFeature,
        AIQualityRankingFeature,
        ShowRankingFeaturesFeature,
    ]),
    SECTION(t('PSI Extensions'), [
        CommentSliderFeature,
        TranslationFeature,
        VideoQuoteFeature,
        ArticleTopicTaggingFeature,
        ConvoMatchFeature,
        CommunityGuidelinesFeature,
    ]),
    SECTION(t('Moderation'), [
        HideRejectedFeature,
        COMPOSITE(PreModeratorFeature, [ModerateWithGPTFeature, ModerateWithJigsawFeature, BlocklistFeature]),
        AutoApproveFeature,
        ReportCommentFeature,
        HumanReviewsEverythingFeature,
        CloseConversationFeature,
    ]),
];

export const simpleCommentsDefaultConfig = {
    openlinksinnewtab: true,
    premoderator: true,
    articletopictagging: false,
    convomatch: false,
    translationfeature: false,
    hide_rejected: true,
    premoderation: true,
    aimoderation: true,
    jigsawmoderation: true,
    strictreplymoderation: true,
    report_comment: true,
};
